import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { Typography } from '@mui/material';

import settings from '../../settings/settings';

import './Splash.scss';

function Splash() {
  const navigate = useNavigate();
  const { isAuthorized } = useContext(AuthContext);

  const logoURL = `${settings.BASE_PATH_IMAGES_FOLDER}/logo-vc-agente-web.svg`;

  useEffect(() => {
    setTimeout(() => {
      navigate(isAuthorized ? '/home' : '/tutorial');
    }, 3000);
  }, [isAuthorized, navigate]);

  return (
    <div className="outter-page splash-page">
      <div className="outter-page-content-container">
        <img src={logoURL} className="App-logo" alt="logo" />
        <Typography variant="h1" component="h1" className="app-name">
          <b>Você Agente</b>
        </Typography>
        <Typography variant="p" component="p" className="app-message">
          Ajude sua cidade<br /> a ficar livre de vetores de doenças!
        </Typography>
      </div>
    </div>
  );
}

export default Splash;
